
import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack} from 'views/components';
import {Map, Translate} from 'views/module';

const ContentEdit = (props) => {
  const bioQuestion = props.bioQuestion;
  const updateQuestionData = props.updateQuestionData;

  const {bioQuestionId, questionData: {latitude, longitude}} = bioQuestion;

  const handleChange = (coords) => {
    updateQuestionData({
      latitude: coords.lat,
      longitude: coords.lng,
    });
  };

  return (
    <Stack>
      <Typography variant='subtitle1' fontWeight='bold'>
        <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`} />:
      </Typography>

      <Map
        width='100%'
        height='200px'
        coordinates={[latitude, longitude]}
        onLocationClick={(coords) => handleChange(coords)}
      />
    </Stack>
  );
};

ContentEdit.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  updateQuestionData: PropTypes.func.isRequired,
};

export default ContentEdit;
